import { EventBus } from '@/utils/event-bus.js'
import store from '@/store'

/**
 * 区块信息事件监听
 */
export function blockEventListener() {
    const currentAccount = store.state.wallet.account
    if (!currentAccount) {
        console.log('未找到账户信息,无法监听区块事件')
        return
    }
    console.log('Listen events with:', currentAccount.walletName)
    const client = store.state.wallet.client
    client.on('notification', n => {
        console.log('事件:', n)
        // 发送交易时type类型:NewTxProposal=>TxProposalAcceptedBy=>TxProposalFinallyAccepted=>NewOutgoingTx=>TxConfirmation
        // 接收交易时type类型:NewIncomingTx
        // 其他: NewBlock
        if (
            n.type == 'NewOutgoingTx' ||
      n.type == 'NewIncomingTx' ||
      n.type == 'NewBlock' ||
      n.type == 'TxProposalAcceptedBy' ||
      n.type == 'TxProposalFinallyAccepted' ||
      n.type == 'TxProposalRemoved'
        ) {
            /**
       * 更新余额
       */
            store.dispatch('wallet/updateAccountCache')
        }

        if (n.type == 'ScanFinished') {
            /**
       * 更新是否完成扫描状态
       */
            store.dispatch('wallet/updateScanStatus', new Date())
        }

        if (n.type == 'NewCopayer') {
            /**
       * 更新状态
       */
            store.dispatch('wallet/updateAccountCache')
        }
        if (n.type == 'WalletComplete') {
            EventBus.$emit('vircle_reload', null)
        }
    })
    client.initialize(
        {
            notificationIncludeOwn: true
        },
        err => {
            if (err) {
                console.log('Could not init notifications err:', err)
            }
            client.setNotificationsInterval(20) // 周期20s
        }
    )
    return
}



// WEBPACK FOOTER //
// ./src/utils/eventListener.js